import { render } from "./OpenSourceSingle.vue?vue&type=template&id=27a3b79d&ts=true"
import script from "./OpenSourceSingle.vue?vue&type=script&lang=ts"
export * from "./OpenSourceSingle.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/digital-creative-website/digital-creative-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__